(function () {
  var doc = document.documentElement;

  /* wordmark letters fade in */
  var wm = document.querySelector('.wordmark');
  if (wm) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      wm.classList.add('lit');
    } else {
      requestAnimationFrame(function () { wm.classList.add('lit'); });
    }
  }

  /* scroll reveal — belt and braces: IntersectionObserver when available, a scroll/resize
     check as fallback, and layout/theme.liquid adds html.reveal-all after 4 s regardless,
     so nothing can stay invisible on a phone that never fires the observer. */
  var items = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
  function show(el) { el.classList.add('in'); }
  function check() {
    if (!items.length) { return; }
    var vh = window.innerHeight || doc.clientHeight;
    items = items.filter(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom > 0 && r.top < vh * 0.96) { show(el); return false; }
      return true;
    });
  }
  if (items.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0, rootMargin: '0px 0px -4% 0px' });
      items.forEach(function (el) { io.observe(el); });
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    window.addEventListener('load', check);
    check();
    setTimeout(function () { items.forEach(show); items = []; }, 4000);
  }

  /* phone menu: close when tapping outside or pressing Escape */
  var mnav = document.getElementById('MobileNav');
  if (mnav) {
    document.addEventListener('click', function (e) {
      if (mnav.open && !mnav.contains(e.target)) { mnav.open = false; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mnav.open) { mnav.open = false; }
    });
  }
})();
